import './App.css';
import Inicio from './components/Inicio/Inicio';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Nosotros from './components/Nosotros/Nosotros';
import Certificaciones from './components/Certificaciones/Certificaciones';
import Contacto from './components/Contacto/Contacto';
import Servicios from './components/Servicios/Servicios';

function App() {
  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Inicio />} />
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/certificaciones" element={<Certificaciones />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/servicios" element={<Servicios />} />

        </Routes>
      </Router>    </div>
  );
}

export default App;
